// The box that brings video back for a single match is only worth offering where the
// match would otherwise be assessed without it. On the fixture page the server knows
// that already; on the add/edit form the customer and the competition are still being
// chosen, so the decision has to follow the selects.
//
// The data rides on the container - the customer's own flag and a map of the listed
// competitions - so switching either select is a local operation.

const CONTAINER_ID = "fixture-video-required";

const container = () => document.getElementById(CONTAINER_ID);

const parseMap = (element) => {
  try {
    return JSON.parse(element.dataset.competitions || "{}");
  } catch (error) {
    return {};
  }
};

// Everything the customer's selection brings with it, replacing what the page was
// rendered with.
export function updateFixtureVideoData(result) {
  const element = container();
  if (!element) return;

  element.dataset.customerVideoRequired = String(result.customer_video_required);

  const map = {};
  (result.competitions || []).forEach((competition) => {
    map[competition.id] = competition.video_required;
  });
  element.dataset.competitions = JSON.stringify(map);
}

export function syncFixtureVideoRequired() {
  const element = container();
  if (!element) return;

  const customerOff = element.dataset.customerVideoRequired === "false";

  const select = document.getElementById("fixture_competition_id");
  const competitionOff = select && select.value ? parseMap(element)[select.value] === false : false;

  const offer = customerOff || competitionOff;
  element.classList.toggle("d-none", !offer);

  // A box that is no longer offered must not still be carrying a yes: the assessor
  // ticked it for a competition they have since moved away from.
  if (!offer) {
    const checkbox = document.getElementById("fixture_video_required");
    if (checkbox) checkbox.checked = false;
  }
}

export function bindFixtureVideoRequired() {
  if (!container()) return;

  syncFixtureVideoRequired();

  $(document)
    .off("change.fixtureVideoRequired")
    .on("change.fixtureVideoRequired", "#fixture_competition_id", syncFixtureVideoRequired);
}
